import React from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import { MenuItemLink, getResources, usePermissions } from 'react-admin';
import DefaultIcon from '@material-ui/icons/ViewList';
import LabelIcon from '@material-ui/icons/Label';
import BarChart from '@material-ui/icons/BarChart';


const Menu = ({ onMenuClick, logout }) => {
    const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('xs'));
    const open = useSelector((state) => state.admin.ui.sidebarOpen);
    const resources = useSelector(getResources);
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <div>
            <React.Fragment>
                <MenuItemLink
                    to="/"
                    primaryText="Dashboard"
                    leftIcon={<LabelIcon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                />
            </React.Fragment>
            {/* {["user", "admin"].includes(usePermissions().permissions) ?  */}
            {resources.filter(r => r.hasList)
                .map((resource) => (
                    <MenuItemLink
                        key={resource.name}
                        to={`/${resource.name}`}
                        primaryText={
                            (resource.options && resource.options.label)
                        }
                        leftIcon={
                            resource.icon ? <resource.icon /> : <DefaultIcon />
                        }
                        onClick={onMenuClick}
                        sidebarIsOpen={open}
                    />
                ))}

            {/* {["user", "admin"].includes(usePermissions().permissions) ? 
            <React.Fragment>
                <MenuItemLink
                    to="/internet"
                    primaryText="Internet"
                    leftIcon={<PermScanWifiIcon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                />
            </React.Fragment>

            : null} */}

            {permissions.includes("reports.list") &&
                <React.Fragment>
                    <MenuItemLink
                        to="/report-machines"
                        primaryText="Reporte de máquinas"
                        leftIcon={<BarChart />}
                        onClick={onMenuClick}
                        sidebarIsOpen={open}
                    />
                </React.Fragment>
            }
            {permissions.includes("reports.list") &&
                <React.Fragment>
                    <MenuItemLink
                        to="/report-machines-time"
                        primaryText="Reporte por fechas"
                        leftIcon={<BarChart />}
                        onClick={onMenuClick}
                        sidebarIsOpen={open}
                    />
                </React.Fragment>
            }

            {isXSmall && logout}
        </div>
    );
};

export default Menu;